"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61 20.6",
    width: "61",
    height: "20.6"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M60.5,16.5h-5.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H60V1H3.3v12.5l6.9,2h21.4c0.3,0,0.5,0.2,0.5,0.5 s-0.2,0.5-0.5,0.5H10.2c0,0-0.1,0-0.1,0l-7.3-2.1c-0.2-0.1-0.4-0.3-0.4-0.5V0.5C2.3,0.2,2.5,0,2.8,0h57.7C60.8,0,61,0.2,61,0.5V16 C61,16.3,60.8,16.5,60.5,16.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M6,18.8c-0.3,0-0.5-0.2-0.5-0.5v-3c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3C6.5,18.6,6.2,18.8,6,18.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M43.4,20.6c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2s3.2,1.4,3.2,3.2C46.6,19.1,45.2,20.6,43.4,20.6z M43.4,15.2c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2s2.2-1,2.2-2.2S44.6,15.2,43.4,15.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M51,20.6c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2 C54.1,19.1,52.7,20.6,51,20.6z M51,15.2c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2c1.2,0,2.2-1,2.2-2.2S52.2,15.2,51,15.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M35.9,20.6c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2s3.2,1.4,3.2,3.2C39.1,19.1,37.7,20.6,35.9,20.6z M35.9,15.2c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2s2.2-1,2.2-2.2S37.1,15.2,35.9,15.2z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "-3.6",
    y: "6.1",
    transform: "matrix(6.513794e-11 1 -1 6.513794e-11 8.6544 5.7671)",
    fill: "#9ECE06",
    width: "10",
    height: "2.2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M2.5,12.5H0.3c-0.2,0-0.3-0.2-0.3-0.3v-10C0,2,0.2,1.9,0.3,1.9h2.2c0.2,0,0.3,0.2,0.3,0.3v10 C2.9,12.4,2.7,12.5,2.5,12.5z M0.7,11.9h1.5V2.6H0.7V11.9z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#9ECE06",
    cx: "43.1",
    cy: "8.4",
    r: "4.7"
  }));
};

exports["default"] = _default;